import type { ConversationType, ItemRow } from 'owa-graph-schema';

/**
 * Gets the priority view lookback cutoff date.
 * On Mondays, looks back to Friday; otherwise looks back to yesterday.
 */
function getPriorityViewCutoff(): Date {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const isMonday = now.getDay() === 1;
    const lookbackDays = isMonday ? 3 : 1;
    const cutoff = new Date(startOfToday);
    cutoff.setDate(cutoff.getDate() - lookbackDays);
    return cutoff;
}

/**
 * Filters item rows to only include items received within the priority lookback window.
 * On Mondays, includes Friday through Monday; otherwise includes today and yesterday.
 * @param rows - Array of ItemRow to filter
 * @returns Filtered array containing only recent items
 */
export function filterItemRowsForPriorityView(rows: ItemRow[]): ItemRow[] {
    const cutoff = getPriorityViewCutoff();

    return rows.filter(row => {
        if (!row.DateTimeReceived) {
            return false;
        }

        const receivedDate = new Date(row.DateTimeReceived);
        return receivedDate >= cutoff;
    });
}

/**
 * Filters conversation rows to only include conversations within the priority lookback window.
 * On Mondays, includes Friday through Monday; otherwise includes today and yesterday.
 * @param rows - Array of ConversationType to filter
 * @returns Filtered array containing only recent conversations
 */
export function filterConversationRowsForPriorityView(
    rows: ConversationType[]
): ConversationType[] {
    const cutoff = getPriorityViewCutoff();

    return rows.filter(row => {
        if (!row.LastDeliveryTime) {
            return false;
        }

        const lastDeliveryDate = new Date(row.LastDeliveryTime);
        return lastDeliveryDate >= cutoff;
    });
}
